import { useQueries } from '@tanstack/react-query';
import { getApiInventoryTags, getGetApiInventoryTagsQueryKey, getGetApiInventoryTagsQueryOptions } from '../../api';
import { useGlobalState } from '../../data/Global.state';
import { useAtomValue } from 'jotai/index';
import { auth } from '../../data/atoms.auth';

export const useSelectedTenantTags = () => {
  const { selectedTenantIds } = useGlobalState('selectedTenantIds');
  const apiToken = useAtomValue(auth.apiTokenAtom);

  return useQueries({
    queries: selectedTenantIds.map((selectedTenantId) => ({
      queryKey: [...getGetApiInventoryTagsQueryKey(), selectedTenantId],
      queryFn: () =>
        getApiInventoryTags({
          ...getGetApiInventoryTagsQueryOptions(),
          headers: {
            'x-tenant-id': selectedTenantId,
          },
        }),
      enabled: !!apiToken && selectedTenantIds?.length > 0,
      staleTime: 1000 * 60 * 10,
    })),
    combine: (results) => {
      const selectedTenantTags = results.flatMap((ar) => ar.data?.data ?? []) as string[];

      // Filter out system tags that users shouldn't see, specifically the ones for RevPro / TKTEdge
      const filteredTags = selectedTenantTags.filter((tag) => !tag.startsWith('RP_'));

      return [...new Set(filteredTags.map((t) => t.toUpperCase()))];
    },
  });
};
